import procedimentos from './procedimentos.json';

// Opções do formulário de agendamento. Derivadas da lista oficial para que o
// formulário nunca ofereça um procedimento que o site não tem (ou esqueça um).
export const procedureGroups = procedimentos.map((g) => ({
  label: g.label,
  options: g.items.map((p) => p.name),
}));
